import type MailboxInfo from './MailboxInfo';

/**
 * Specialization of the MailboxInfo type for message files (e.g. a .msg file);
 * note that these mailboxes are NOT associated with any account
 */
export interface MessageFileMailboxInfo extends MailboxInfo {
    readonly type: 'MessageFile';
    readonly messageFileType: 'MsgFile';
}

/**
 * Predicate function to check if the mailboxInfo is a MessageFileMailboxInfo
 */
export function isMessageFileMailboxInfo(
    mailboxInfo?: MailboxInfo
): mailboxInfo is MessageFileMailboxInfo {
    return mailboxInfo?.type === 'MessageFile';
}
